export var addMessageListener = function (_a) {
    var type = _a.type, callback = _a.callback;
    var listener = function (event) {
        var _a;
        if (((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.type) === type) {
            callback(event.data.payload);
        }
    };
    window.addEventListener('message', listener, false);
    return function () {
        window.removeEventListener('message', listener);
    };
};
